import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M23 2H1v20h22zm-9.5 18.5h-11l7.5-17h4l7.5 17H17l-5-11L9 17h3z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandAdobe = { render };
export {
  brandAdobe as default,
  render
};
//# sourceMappingURL=brand-adobe.svg.js.map
